import React from 'react';
import './SectionHeader.css';
import { Text } from '@raptormaps/text';

export function SectionHeader({ children }: { children: React.ReactNode }) {
  return (
    <div className="section-header">
      <div className="section-header__accent" />
      <Text variant="h2" className="section-header__title">
        {children}
      </Text>
    </div>
  );
}
